import React from 'react';

const IconUser = ({ onClick, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" onClick={onClick}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" transform="translate(-3 -3)" />
      <path fill={color} fillRule="nonzero" d="M12 13c3.391 0 6.5 1.206 8.923 3.212.05.255.077.518.077.788 0 2.21-1.79 4-4 4H7c-2.21 0-4-1.79-4-4 0-.27.027-.534.078-.788C5.5 14.206 8.609 13 12 13zm0 2c-2.548 0-4.97.795-6.986 2.242C5.134 18.232 5.977 19 7 19h10c1.023 0 1.866-.768 1.986-1.759C16.97 15.795 14.548 15 12 15zm0-12c2.486 0 4.5 2.014 4.5 4.5S14.486 12 12 12 7.5 9.986 7.5 7.5 9.514 3 12 3zm0 2c-1.382 0-2.5 1.118-2.5 2.5S10.618 10 12 10s2.5-1.118 2.5-2.5S13.382 5 12 5z" transform="translate(-3 -3)" />
    </g>
  </svg>
);

export default IconUser;
